import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConsoleBufferService } from '../services/console-buffer.service';

@Injectable()
export class HttpErrorCaptureInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          ConsoleBufferService.recordHttpError({
            method: request.method,
            url: request.urlWithParams,
            status: error.status,
            message: error.message
          });
        }
        return throwError(error);
      })
    );
  }
}
